__nha_webpackJsonp([6],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _common = __webpack_require__(1);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _module = __webpack_require__(3);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _util = __webpack_require__(5);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactModal = function (_Module) {
	    _inherits(ContactModal, _Module);
	
	    function ContactModal() {
	        _classCallCheck(this, ContactModal);
	
	        return _possibleConstructorReturn(this, (ContactModal.__proto__ || Object.getPrototypeOf(ContactModal)).apply(this, arguments));
	    }
	
	    _createClass(ContactModal, [{
	        key: 'init',
	        value: function init() {
	            var _this2 = this;
	
	            return _get(ContactModal.prototype.__proto__ || Object.getPrototypeOf(ContactModal.prototype), 'init', this).call(this).then(function () {
	                return _this2.emit('init');
	            });
	        }
	    }, {
	        key: 'main',
	        value: function main() {
	            var form = $('#form784');
	
	            form.validate({
	                wrapper: 'span',
	                errorClass: 'input-validation-error',
	                errorElement: 'span',
	                errorPlacement: function errorPlacement(err, el) {
	                    el.closest('.nha-form-group').addClass('nha-form-error');
	                    err.addClass('field-validation-error').addClass('nha-form-error-desc');
	                    err.insertAfter(el);
	                    err.removeAttr('style');
	                }
	            });
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            var _this3 = this;
	
	            $('#form784').on('click.validate focusin.validate focusout.validate keyup.validate', function (e) {
	                return _this3.onFormChanged(e);
	            });
	            $('#form784').on('focusout.validate', _util2.default.debounce(function (e) {
	                return _this3.onFormBlurred(e);
	            }));
	            $('#form784').on('submit', function (e) {
	                e.preventDefault();
	
	                if ($('#form784').valid()) {
	                    $.post($('#form784').attr('action'), $('#form784').serialize());
	                    $('#form784 .nha-contact-me-body').hide();
	                    $('#nha-modal-confirmation').show();
	                }
	            });
	        }
	    }, {
	        key: 'onFormBlurred',
	        value: function onFormBlurred(e) {
	            $(e.target).valid(); // validate the field that was blurred
	            this.onFormChanged(e);
	        }
	    }, {
	        key: 'onFormChanged',
	        value: function onFormChanged(e) {
	            $('form#form784 .nha-form-control').each(function (i, el) {
	                var field = $(el);
	                var group = field.closest('.nha-form-group');
	
	                group.removeClass('nha-form-error');
	                if (field.hasClass('input-validation-error') && !field.hasClass('valid')) group.addClass('nha-form-error');
	                group.find('.nha-form-error-desc').removeAttr('style');
	            });
	        }
	    }]);
	
	    return ContactModal;
	}(_module2.default);
	
	var contactModal = new ContactModal();
	
	_common2.default.on('init', function () {
	    return contactModal.init();
	});
	
	exports.default = contactModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _module = __webpack_require__(3);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _util = __webpack_require__(5);
	
	var _util2 = _interopRequireDefault(_util);
	
	__webpack_require__(9);
	
	var _jqueryMaskPlugin = __webpack_require__(10);
	
	var _jqueryMaskPlugin2 = _interopRequireDefault(_jqueryMaskPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import $ from 'jquery';
	
	
	var SCHOOL_PATTERN = /\/schools\/([\w-]+)\/*/ig;
	
	/**
	 * @class Common
	 * @extends {Module}
	 */
	
	var Common = function (_Module) {
		_inherits(Common, _Module);
	
		function Common(options) {
			_classCallCheck(this, Common);
	
			var _this = _possibleConstructorReturn(this, (Common.__proto__ || Object.getPrototypeOf(Common)).call(this, options));
	
			window.dynamicModal = [];
			_this.$transparencyExpanded = $('.nha-transparency-report-expanded');
			return _this;
		}
	
		_createClass(Common, [{
			key: 'init',
			value: function init() {
				var _this2 = this;
	
				// sub-modules must emit an `init` event
				return _get(Common.prototype.__proto__ || Object.getPrototypeOf(Common.prototype), 'init', this).call(this).then(function (e) {
					return _this2.emit('init', e);
				});
			}
		}, {
			key: 'main',
			value: function main() {
				this.mobilePagination();
				this.modalIframe();
				this.modalInline();
				this.modalAuthor();
				this.setBodyPadding();
			}
	
			/**
	   * @listens window#load
	   * @listens window#resize
	   * @memberof Common
	   */
	
		}, {
			key: 'bindEvents',
			value: function bindEvents() {
				var _this3 = this;
	
				_get(Common.prototype.__proto__ || Object.getPrototypeOf(Common.prototype), 'bindEvents', this).call(this);
	
				// phone mask
				$('.nha-form-control.nha-phone-mask').mask('(000) 000-0000');
	
				// corporate header search desktop
				$('.nha-header-search-btn').on('click', function (e) {
					e.stopPropagation();
					var target = $(e.currentTarget);
	
					target.parent('li').addClass('nha-search-expanded');
					$('.nha-header-search-input input').focus();
				});
	
				$('#header-right-search').on('click', function (e) {
					e.stopPropagation();
				});
	
				$(document.body).on('click', function (e) {
					$('.nha-search-expanded').removeClass('nha-search-expanded');
				});
	
				$('.nha-live-chat-tab').on('click', function (e) {
					$(".lebtn div").trigger("click");
				});
	
				$('.nha-nav-primary > li > ul > li a').on('keydown', function (e) {
					_this3.closingNav(e);
				});
	
				//aria tags
				this.initAriaExpanded();
	
				var navObserver = new ResizeObserver(function (mutations) {
					var targetElements = $('.nha-nav-primary > li > ul');
					targetElements.each(function () {
						var height = $(this).height();
						if (height > 0) {
							$(this).prev().attr('aria-expanded', 'true');
						} else {
							$(this).prev().attr('aria-expanded', 'false');
						}
					});
				});
	
				//start observing
				$('.nha-nav-primary > li > ul').each(function () {
					navObserver.observe(this);
				});
	
				// mobile nav
				$('.nha-nav-toggle').on('click', function (e) {
					_this3.mobileNav(e);
				});
				$('.nha-nav .nha-nav-top-item').on('click', function (e) {
					_this3.mobileNavItem(e);
				});
				$('.nha-nav .nha-nav-top-item').on('keydown', function (e) {
					_this3.tabbingNav(e);
				});
	
				$(document).on('keydown', function (event) {
					var target = $('.nha-nav-toggle');
					if (event.key === "Escape" && target.hasClass('open')) {
						target.toggleClass('open');
						$('.nha-nav').toggleClass('open').css('visibility', 'visible');
					}
				});
	
				$('.nha-transparency-report-expanded .nha-btn').on('click', function (e) {
					_this3.$transparencyExpanded.fadeOut();
				});
	
				$(document).on('keyup', function (event) {
					if (event.key === "Enter" && $('.nha-education-circle').is(":focus")) {
						$('.nha-transparency-report-expanded').fadeIn();
						$('.nha-transparency-report-expanded').find('a').trigger('focus');
					}
				});
	
				$('.nha-education-circle-link').on('click', function (e) {
					_this3.$transparencyExpanded.fadeIn();
					_this3.$transparencyExpanded.find('.nha-btn').focus();
				});
	
				$('.nha-education-circle').on('click', function (e) {
					_this3.$transparencyExpanded.fadeIn();
					_this3.$transparencyExpanded.find('.nha-btn').focus();
				});
	
				$(window).on('scroll', function (e) {
					_this3.$transparencyExpanded.fadeOut();
				});
	
				$(window).on('resize', _util2.default.debounce(function (e) {
					return _this3.onResize(e);
				}));
			}
	
			/**
	   * Parses the url for the culture code
	   * @memberof Common
	   * @returns {string} The two-letter cultureCode
	   */
	
		}, {
			key: 'getCultureCode',
			value: function getCultureCode() {
				var path = window.location.pathname + '/';
	
				if (this.isSchoolSite) {
					var matches = /\/schools\/([\w-]+)\/*/ig.exec(path);
	
					if (matches != null) {
						var index = matches[0].length;
						return _util2.default.trim(path.substring(index, path.indexOf('/', index)), '/');
					}
				} else {
					var _matches = /\/(en|es)/gi.exec(path);
					if (_matches != null) return _util2.default.trim(_matches[0], '/');
				}
			}
		}, {
			key: 'onResize',
	
	
			/**
	   * Called when the window is resized (after being debounced)
	   * 
	   * @param {ResizeEvent} e 
	   * @memberof Common
	   */
			value: function onResize(e) {
				if (_util2.default.checkWidth() === _util.ViewPort.Desktop) {
					// reset mobile nav
					$('.nha-nav .nha-nav-top-item').removeClass('open');
					$('.nha-nav .nha-nav-primary > li ul').removeAttr('style');
					$('.nha-nav-toggle').removeClass('open');
					$('.nha-nav').removeClass('open').removeAttr('style');
				}
	
				this.mobilePagination();
	
				this.setBodyPadding();
			}
		}, {
			key: 'initAriaExpanded',
			value: function initAriaExpanded() {
				var menuItems = $('.nha-nav-top-item');
				menuItems.each(function () {
					$(this).attr('aria-expanded', 'false');
				});
			}
		}, {
			key: 'mobileNav',
			value: function mobileNav(e) {
				var target = $(e.currentTarget);
	
				target.toggleClass('open');
				$('.nha-nav').toggleClass('open').css('visibility', 'visible');
			}
		}, {
			key: 'mobileNavItem',
			value: function mobileNavItem(e) {
				var target = $(e.currentTarget);
	
				if (_util2.default.checkWidth() !== 'desktop') {
					target.toggleClass('open');
					target.closest('li').find('ul').slideToggle();
				}
			}
		}, {
			key: 'setBodyPadding',
			value: function setBodyPadding() {
				if (_util2.default.checkWidth() !== _util.ViewPort.Desktop) {
					var headerHeight = $('.nha-header-schools').outerHeight();
					$('body').css('padding-top', headerHeight);
				} else {
					$('body').removeAttr('style');
				}
			}
		}, {
			key: 'tabbingNav',
			value: function tabbingNav(e) {
				var target = $(e.currentTarget);
				var children = target.parent().find('ul li a');
	
				if ((e.key === "enter" || e.keyCode === 13) && target.parent().find('ul').length > 0) {
					e.preventDefault();
					this.mobileNavItem(e);
					target.parent().addClass('focused');
	
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var child = _step.value;
	
							$(child).removeAttr('tabindex');
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					if (target.parent().hasClass('focused')) {
						//target.unbind(e);
					}
				}
	
				var $activeElem = $(document.activeElement);
				var $prevItem = $activeElem.parent().prev();
	
				if (e.shiftKey && e.keyCode === 9 || e.keyCode === 27) {
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;
	
					try {
						for (var _iterator2 = $activeElem.parent().prev().find('ul li a')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var child = _step2.value;
	
							$(child).attr('tabindex', '-1');
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
	
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;
	
					try {
						for (var _iterator3 = $activeElem.parent().find('ul li a')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var child = _step3.value;
	
							$(child).attr('tabindex', '-1');
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
	
					$('.nha-nav .nha-nav-primary > li').removeClass('focused');
				}
	
				if ($prevItem.hasClass('focused')) {
					$prevItem.removeClass('focused');
				}
			}
		}, {
			key: 'closingNav',
			value: function closingNav(e) {
				var target = $(e.currentTarget);
				var menuItem = target.parent().parent().parent();
	
				if (e.keyCode === 27) {
					e.preventDefault();
					target.blur();
	
					var children = target.parent().parent().children().find('a');
	
					if (children !== undefined) {
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;
	
						try {
							for (var _iterator4 = children[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var child = _step4.value;
	
								$(child).attr('tabindex', '-1');
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}
					}
	
					$('.nha-nav .nha-nav-primary > li').removeClass('focused');
					menuItem.attr('tabindex', '-1');
					menuItem.find('a.nha-nav-top-item').focus();
				}
			}
		}, {
			key: 'mobilePagination',
			value: function mobilePagination() {
				if ($('.nha-pagination .js-li-pagination-number ').length > 3) {
					if ($('.js-li-pagination-number.active').prev().hasClass('nha-pagination-previous')) {
						$('.js-li-pagination-number.active').next().addClass('nha-page-show-mobile');
						$('.js-li-pagination-number.active').next().next().addClass('nha-page-show-mobile');
					} else if ($('.js-li-pagination-number.active').next().hasClass('nha-pagination-next')) {
						$('.js-li-pagination-number.active').prev().addClass('nha-page-show-mobile');
						$('.js-li-pagination-number.active').prev().prev().addClass('nha-page-show-mobile');
					} else {
						$('.js-li-pagination-number.active').prev().addClass('nha-page-show-mobile');
						$('.js-li-pagination-number.active').next().addClass('nha-page-show-mobile');
					}
				}
			}
		}, {
			key: 'modalInline',
			value: function modalInline() {
				$('.modal-inline').modaal({
					type: 'inline',
					width: 725,
					background_scroll: false,
					before_open: function before_open() {
						if (_util2.default.checkWidth() !== _util.ViewPort.Desktop) {
							$('body').css('position', 'fixed');
						}
					},
					after_open: function after_open() {},
					after_close: function after_close() {
						$('body').removeAttr('style');
					}
				});
			}
		}, {
			key: 'modalAuthor',
			value: function modalAuthor() {
				$('.modal-author').modaal({
					type: 'inline',
					width: 725,
					custom_class: 'nha-profile-modal',
					background_scroll: false,
					before_open: function before_open() {
						if (_util2.default.checkWidth() !== _util.ViewPort.Desktop) {
							$('body').css('position', 'fixed');
						}
					},
					after_open: function after_open() {},
					after_close: function after_close() {
						$('body').removeAttr('style');
					}
				});
	
				$(window).bind('orientationchange', function (event) {
					if ($('.modaal-wrapper').length) {
						$('.modal-inline').modaal('close');
					}
				});
			}
		}, {
			key: 'modalIframe',
			value: function modalIframe() {
				var IFrame;
	
				$('.modal-iframe').modaal({
					type: 'iframe',
					width: 600,
					background_scroll: false,
					before_open: function before_open() {
						if (_util2.default.checkWidth() !== _util.ViewPort.Desktop) {
							$('body').css('position', 'fixed');
							$('.modaal-wrapper').addClass('modal-scrollfix');
						}
					},
					after_open: function after_open() {
						IFrame = iFrameResize({
							heightCalculationMethod: 'lowestElement'
						}, 'iframe.modaal-iframe-elem');
	
						$('.modaal-wrapper').removeClass('modal-scrollfix');
						$('body').css('overflow', 'hidden').css('position', 'relative');
					},
					after_close: function after_close() {
						IFrame[0].iFrameResizer.close();
						$('body').removeAttr('style');
					}
				});
			}
		}, {
			key: 'isSchoolSite',
			get: function get() {
				return SCHOOL_PATTERN.test(window.location.pathname);
			}
		}]);
	
		return Common;
	}(_module2.default);
	
	// create an instance to export for other modules to reference
	
	
	var common = new Common();
	
	exports.default = common;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(4);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Emitted when a Module resolve from Module.init(). All sub-modules are required to emit this event.
	 * @event Module#init
	 * 
	 */
	
	/**
	 * A Module privodes a scope for controller logic within a page. Inspired by the Revealing Pattern
	 * 
	 * @class Module
	 * @extends {EventEmitter}
	 * @property {boolean} initialized Indicates if the module has been initialized, ie. the module emitted the `init` event
	 */
	var Module = function (_EventEmitter) {
		_inherits(Module, _EventEmitter);
	
		/**
	     * Creates an instance of Module.
	     * @param {object} [options={}] 
	     * @memberof Module
	     */
		function Module(options) {
			_classCallCheck(this, Module);
	
			var _this = _possibleConstructorReturn(this, (Module.__proto__ || Object.getPrototypeOf(Module)).call(this));
	
			_this._options = Object.assign({}, options);
	
			_this.initialized = false;
			return _this;
		}
	
		/**
	     * Bind events to the module. These could be DOM events, service events, or module events, etc. Should be overriden by sub-classes.
	     * 
	  * @override
	     * @memberof Module
	  * @listens Module#init
	     */
	
	
		_createClass(Module, [{
			key: 'bindEvents',
			value: function bindEvents() {}
		}, {
			key: '_bindEvents',
			value: function _bindEvents() {
				var _this2 = this;
	
				this.on('init', function (e) {
					_this2.initialized = true;
					_this2.main();
				});
			}
	
			/**
	      * Initializes the module. Any sub-module must override this method to emit an `init` event
	      * 
	      * @returns {Promise.<void>} A promise that resolves when initialization is finished
	      * @memberof Module
	      */
	
		}, {
			key: 'init',
			value: function init() {
				var _this3 = this;
	
				return new Promise(function (resolve) {
	
					_this3._bindEvents();
					_this3.bindEvents();
	
					// other work
	
					return resolve();
				});
			}
	
			/**
	   * Called when the `init` event is emitted. Should be overriden by sub-classes.
	   * 
	   * @override
	   * @memberof Module
	   */
	
		}, {
			key: 'main',
			value: function main() {}
		}]);
	
		return Module;
	}(_events2.default);
	
	exports.default = Module;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
		Modaal - accessible modals - v0.3.1
		by Humaan, for all humans.
		http://humaan.com
	 */
	!function(a){var t='<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',o={init:function(t,o){var e=this;e.dom=a("body"),e.$elem=a(o),e.options=a.extend({},a.fn.modaal.options,e.$elem.data(),t),e.xhr=null,e.scope={is_open:!1,id:"modaal_"+(new Date).getTime()+Math.random().toString(16).substring(2)},e.$elem.attr("data-modaal-scope",e.scope.id),e.private_options={active_class:"is_active"},e.lastFocus=null,e.options.is_locked||"confirm"==e.options.type||e.options.hide_close?e.scope.close_btn="":e.scope.close_btn='<button type="button" class="modaal-close" id="modaal-close" aria-label="'+e.options.close_aria_label+'"><span>'+e.options.close_text+"</span></button>","none"===e.options.animation&&(e.options.animation_speed=0,e.options.after_callback_delay=0),a(o).on("click.Modaal",function(a){a.preventDefault();var t;if(e.lastFocus=document.activeElement,e.options.should_open!==!1&&("function"!=typeof e.options.should_open||e.options.should_open()!==!1)){switch(e.options.before_open.call(e,a),e.options.type){case"inline":e.create_basic();break;case"ajax":t=e.options.source(e.$elem,e.$elem.attr("href")),e.fetch_ajax(t);break;case"confirm":e.options.is_locked=!0,e.create_confirm();break;case"image":e.create_image();break;case"iframe":t=e.options.source(e.$elem,e.$elem.attr("href")),e.create_iframe(t);break;case"video":e.create_video(e.$elem.attr("href"));break;case"instagram":e.create_instagram()}e.watch_events()}}),e.options.start_open===!0&&a(o).click()},watch_events:function(){var t=this;t.dom.off("click.Modaal keyup.Modaal keydown.Modaal"),t.dom.on("keydown.Modaal",function(o){var e=o.keyCode,i=o.target;9==e&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find('*[tabindex="0"]').focus())}),t.dom.on("keyup.Modaal",function(o){var e=o.keyCode,i=o.target;return o.shiftKey&&9==o.keyCode&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find(".modaal-close").focus()),!t.options.is_locked&&27==e&&t.scope.is_open?a(document.activeElement).is("input:not(:checkbox):not(:radio)")?!1:void t.modaal_close():"image"==t.options.type?(37==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-prev").hasClass("is_hidden")&&t.gallery_update("prev"),void(39==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-next").hasClass("is_hidden")&&t.gallery_update("next"))):void 0}),t.dom.on("click.Modaal",function(o){var e=a(o.target);if(!t.options.is_locked&&(t.options.overlay_close&&e.is(".modaal-inner-wrapper")||e.is(".modaal-close")||e.closest(".modaal-close").length))return void t.modaal_close();if(e.is(".modaal-confirm-btn"))return e.is(".modaal-ok")&&t.options.confirm_callback.call(t,t.lastFocus),e.is(".modaal-cancel")&&t.options.confirm_cancel_callback.call(t,t.lastFocus),void t.modaal_close();if(e.is(".modaal-gallery-control")){if(e.hasClass("is_hidden"))return;return e.is(".modaal-gallery-prev")&&t.gallery_update("prev"),void(e.is(".modaal-gallery-next")&&t.gallery_update("next"))}})},build_modal:function(a){var t=this,o="";"instagram"==t.options.type&&(o=" modaal-instagram");var e,i="video"==t.options.type?"modaal-video-wrap":"modaal-content";switch(t.options.animation){case"fade":e=" modaal-start_fade";break;case"slide-down":e=" modaal-start_slidedown";break;default:e=" modaal-start_none"}var l="";t.options.fullscreen&&(l=" modaal-fullscreen"),""===t.options.custom_class&&"undefined"==typeof t.options.custom_class||(t.options.custom_class=" "+t.options.custom_class);var s="";t.options.width&&t.options.height&&"number"==typeof t.options.width&&"number"==typeof t.options.height?s=' style="max-width:'+t.options.width+"px;height:"+t.options.height+'px;overflow:auto;"':t.options.width&&"number"==typeof t.options.width?s=' style="max-width:'+t.options.width+'px;"':t.options.height&&"number"==typeof t.options.height&&(s=' style="height:'+t.options.height+'px;overflow:auto;"'),("image"==t.options.type||"video"==t.options.type||"instagram"==t.options.type||t.options.fullscreen)&&(s="");var n='<div class="modaal-wrapper modaal-'+t.options.type+e+o+l+t.options.custom_class+'" id="'+t.scope.id+'"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper">';"video"!=t.options.type&&(n+='<div class="modaal-container"'+s+">"),n+='<div class="'+i+' modaal-focus" aria-hidden="false" aria-label="'+t.options.accessible_title+' (Press escape to close)" role="dialog">',n+="inline"==t.options.type?'<div class="modaal-content-container"></div>':a,n+="</div>"+t.scope.close_btn,"video"!=t.options.type&&(n+="</div>"),n+="</div></div></div>",t.dom.append(n),"inline"==t.options.type&&a.appendTo("#"+t.scope.id+" .modaal-content-container"),t.modaal_overlay("show")},create_basic:function(){var t=this,o=t.$elem.is("[href]")?a(t.$elem.attr("href")):t.$elem,e="";o.length?(e=o.contents().clone(!0,!0),o.empty()):e="Content could not be loaded. Please check the source and try again.",t.build_modal(e)},create_instagram:function(){var t=this,o=t.options.instagram_id,e="",i="Instagram photo couldn't be loaded, please check the embed code and try again.";if(t.build_modal('<div class="modaal-content-container'+(""!=t.options.loading_class?" "+t.options.loading_class:"")+'">'+t.options.loading_content+"</div>"),""!=o&&null!==o&&void 0!==o){var l="https://api.instagram.com/oembed?url=http://instagr.am/p/"+o+"/";a.ajax({url:l,dataType:"jsonp",cache:!1,success:function(o){e=o.html;var i=a("#"+t.scope.id+" .modaal-content-container");i.length>0&&(i.removeClass(t.options.loading_class),i.html(e),window.instgrm.Embeds.process())},error:function(){e=i;var o=a("#"+t.scope.id+" .modaal-content-container");o.length>0&&(o.removeClass(t.options.loading_class).addClass(t.options.ajax_error_class),o.html(e))}})}else e=i;return!1},fetch_ajax:function(t){var o=this;null==o.options.accessible_title&&(o.options.accessible_title="Dialog Window"),null!==o.xhr&&(o.xhr.abort(),o.xhr=null),o.build_modal('<div class="modaal-content-container'+(""!=o.options.loading_class?" "+o.options.loading_class:"")+'">'+o.options.loading_content+"</div>"),o.xhr=a.ajax(t,{success:function(t){var e=a("#"+o.scope.id).find(".modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class),e.html(t),o.options.ajax_success.call(o,e))},error:function(t){if("abort"!=t.statusText){var e=a("#"+o.scope.id+" .modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class).addClass(o.options.ajax_error_class),e.html("Content could not be loaded. Please check the source and try again."))}}})},create_confirm:function(){var a,t=this;a='<div class="modaal-content-container"><h1 id="modaal-title">'+t.options.confirm_title+'</h1><div class="modaal-confirm-content">'+t.options.confirm_content+'</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">'+t.options.confirm_button_text+'</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">'+t.options.confirm_cancel_button_text+"</button></div></div></div>",t.build_modal(a)},create_image:function(){var t,o,e=this,i="",l='<button type="button" class="modaal-gallery-control modaal-gallery-prev" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>',s='<button type="button" class="modaal-gallery-control modaal-gallery-next" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>';if(e.$elem.is("[rel]")){var n=e.$elem.attr("rel"),d=a('[rel="'+n+'"]');d.removeAttr("data-gallery-active","is_active"),e.$elem.attr("data-gallery-active","is_active"),o=d.length-1;var r=[];i='<div class="modaal-gallery-item-wrap">',d.each(function(a,t){var o="",e="",i="",l=!1,s=t.getAttribute("data-modaal-desc"),n=t.getAttribute("data-gallery-active");""!==t.href||void 0!==t.href?o=t.href:""===t.src&&void 0===t.src||(o=t.src),""!=s&&null!==s&&void 0!==s?(e=s,i='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(a+1)+" - </span>"+s+"</div>"):i='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(a+1)+"</span></div>",n&&(l=!0);var d={url:o,alt:e,rawdesc:s,desc:i,active:l};r.push(d)});for(var c=0;c<r.length;c++){var m="",p=r[c].rawdesc?"Image: "+r[c].rawdesc:"Image "+c+" no description";r[c].active&&(m=" "+e.private_options.active_class),i+='<div class="modaal-gallery-item gallery-item-'+c+m+'" aria-label="'+p+'"><img src="'+r[c].url+'" alt=" " style="width:100%">'+r[c].desc+"</div>"}i+="</div>"+l+s}else{var _=e.$elem.attr("href"),v="",f="",p="";e.$elem.attr("data-modaal-desc")?(p=e.$elem.attr("data-modaal-desc"),v=e.$elem.attr("data-modaal-desc"),f='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>'+v+"</div>"):p="Image with no description",i='<div class="modaal-gallery-item is_active" aria-label="'+p+'"><img src="'+_+'" alt=" " style="width:100%">'+f+"</div>"}t=i,e.build_modal(t),a(".modaal-gallery-item.is_active").is(".gallery-item-0")&&a(".modaal-gallery-prev").hide(),a(".modaal-gallery-item.is_active").is(".gallery-item-"+o)&&a(".modaal-gallery-next").hide()},gallery_update:function(t){var o=this,e=a("#"+o.scope.id),i=e.find(".modaal-gallery-item"),l=i.length-1;if(0==l)return!1;var s=e.find(".modaal-gallery-prev"),n=e.find(".modaal-gallery-next"),d=250,r=0,c=0,m=e.find(".modaal-gallery-item."+o.private_options.active_class),p="next"==t?m.next(".modaal-gallery-item"):m.prev(".modaal-gallery-item");return o.options.before_image_change.call(o,m,p),"prev"==t&&e.find(".gallery-item-0").hasClass("is_active")?!1:"next"==t&&e.find(".gallery-item-"+l).hasClass("is_active")?!1:void m.stop().animate({opacity:0},d,function(){p.addClass("is_next").css({position:"absolute",display:"block",opacity:0});var t=a(document).width(),i=t>1140?280:50;r=e.find(".modaal-gallery-item.is_next").width(),c=e.find(".modaal-gallery-item.is_next").height();var _=e.find(".modaal-gallery-item.is_next img").prop("naturalWidth"),v=e.find(".modaal-gallery-item.is_next img").prop("naturalHeight");_>t-i?(r=t-i,e.find(".modaal-gallery-item.is_next").css({width:r}),e.find(".modaal-gallery-item.is_next img").css({width:r}),c=e.find(".modaal-gallery-item.is_next").find("img").height()):(r=_,c=v),e.find(".modaal-gallery-item-wrap").stop().animate({width:r,height:c},d,function(){m.removeClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeAttr("style"),m.find("img").removeAttr("style"),p.addClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeClass("is_next").css("position",""),p.stop().animate({opacity:1},d,function(){a(this).removeAttr("style").css({width:"100%"}),a(this).find("img").css("width","100%"),e.find(".modaal-gallery-item-wrap").removeAttr("style"),o.options.after_image_change.call(o,p)}),e.find(".modaal-gallery-item").removeAttr("tabindex"),e.find(".modaal-gallery-item."+o.private_options.active_class).attr("tabindex","0").focus(),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-0")?s.stop().animate({opacity:0},150,function(){a(this).hide()}):s.stop().css({display:"block",opacity:s.css("opacity")}).animate({opacity:1},150),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-"+l)?n.stop().animate({opacity:0},150,function(){a(this).hide()}):n.stop().css({display:"block",opacity:s.css("opacity")}).animate({opacity:1},150)})})},create_video:function(a){var t,o=this;t='<iframe src="'+a+'" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>',o.build_modal('<div class="modaal-video-container">'+t+"</div>")},create_iframe:function(a){var t,o=this;t=null!==o.options.width||void 0!==o.options.width||null!==o.options.height||void 0!==o.options.height?'<iframe src="'+a+'" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>':'<div class="modaal-content-container">Please specify a width and height for your iframe</div>',o.build_modal(t)},modaal_open:function(){var t=this,o=a("#"+t.scope.id),e=t.options.animation;"none"===e&&(o.removeClass("modaal-start_none"),t.options.after_open.call(t,o)),"fade"===e&&o.removeClass("modaal-start_fade"),"slide-down"===e&&o.removeClass("modaal-start_slide_down");var i=o;a(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"),i="image"==t.options.type?a("#"+t.scope.id).find(".modaal-gallery-item."+t.private_options.active_class):o.find(".modaal-iframe-elem").length?o.find(".modaal-iframe-elem"):o.find(".modaal-video-wrap").length?o.find(".modaal-video-wrap"):o.find(".modaal-focus"),i.attr("tabindex","0").focus(),"none"!==e&&setTimeout(function(){t.options.after_open.call(t,o)},t.options.after_callback_delay)},modaal_close:function(){var t=this,o=a("#"+t.scope.id);t.options.before_close.call(t,o),null!==t.xhr&&(t.xhr.abort(),t.xhr=null),"none"===t.options.animation&&o.addClass("modaal-start_none"),"fade"===t.options.animation&&o.addClass("modaal-start_fade"),"slide-down"===t.options.animation&&o.addClass("modaal-start_slide_down"),setTimeout(function(){"inline"==t.options.type&&a("#"+t.scope.id+" .modaal-content-container").contents().clone(!0,!0).appendTo(t.$elem.attr("href")),o.remove(),t.options.after_close.call(t),t.scope.is_open=!1},t.options.after_callback_delay),t.modaal_overlay("hide"),null!=t.lastFocus&&t.lastFocus.focus()},modaal_overlay:function(t){var o=this;"show"==t?(o.scope.is_open=!0,o.options.background_scroll||o.dom.addClass("modaal-noscroll"),o.dom.append('<div class="modaal-overlay" id="'+o.scope.id+'_overlay"></div>'),a("#"+o.scope.id+"_overlay").css("background",o.options.background).stop().animate({opacity:o.options.overlay_opacity},o.options.animation_speed,function(){o.modaal_open()})):"hide"==t&&(o.dom.removeClass("modaal-noscroll"),a("#"+o.scope.id+"_overlay").stop().animate({opacity:0},o.options.animation_speed,function(){a(this).remove()}))}};a.fn.modaal=function(t){return this.each(function(){var e=a(this).data("modaal");if(e){if("string"==typeof t)switch(t){case"close":e.modaal_close()}}else{var i=Object.create(o);i.init(t,this),a.data(this,"modaal",i)}})},a.fn.modaal.options={type:"inline",animation:"fade",animation_speed:300,after_callback_delay:350,is_locked:!1,hide_close:!1,background:"#000",overlay_opacity:"0.8",overlay_close:!0,accessible_title:"Dialog Window",start_open:!1,fullscreen:!1,custom_class:"",background_scroll:!1,should_open:!0,close_text:"Close",close_aria_label:"Close (Press escape to close)",width:null,height:null,before_open:function(){},after_open:function(){},before_close:function(){},after_close:function(){},source:function(a,t){return t},confirm_button_text:"Confirm",confirm_cancel_button_text:"Cancel",confirm_title:"Confirm Title",confirm_content:"<p>This is the default confirm dialog content. Replace me through the options</p>",confirm_callback:function(){},confirm_cancel_callback:function(){},gallery_active_class:"gallery_active_item",before_image_change:function(a,t){},after_image_change:function(a){},loading_content:t,loading_class:"is_loading",ajax_error_class:"modaal-error",ajax_success:function(){},instagram_id:null},a(function(){var t=a(".modaal");t.length&&t.each(function(){var t=a(this),o={},e=!1;t.attr("data-modaal-type")&&(e=!0,o.type=t.attr("data-modaal-type")),t.attr("data-modaal-animation")&&(e=!0,o.animation=t.attr("data-modaal-animation")),t.attr("data-modaal-animation-speed")&&(e=!0,o.animation_speed=t.attr("data-modaal-animation-speed")),t.attr("data-modaal-after-callback-delay")&&(e=!0,o.after_callback_delay=t.attr("data-modaal-after-callback-delay")),t.attr("data-modaal-is-locked")&&(e=!0,o.is_locked="true"===t.attr("data-modaal-is-locked")),t.attr("data-modaal-hide-close")&&(e=!0,o.hide_close="true"===t.attr("data-modaal-hide-close")),t.attr("data-modaal-background")&&(e=!0,o.background=t.attr("data-modaal-background")),t.attr("data-modaal-overlay-opacity")&&(e=!0,o.overlay_opacity=t.attr("data-modaal-overlay-opacity")),t.attr("data-modaal-overlay-close")&&(e=!0,o.overlay_close="false"!==t.attr("data-modaal-overlay-close")),t.attr("data-modaal-accessible-title")&&(e=!0,o.accessible_title=t.attr("data-modaal-accessible-title")),t.attr("data-modaal-start-open")&&(e=!0,o.start_open="true"===t.attr("data-modaal-start-open")),t.attr("data-modaal-fullscreen")&&(e=!0,o.fullscreen="true"===t.attr("data-modaal-fullscreen")),t.attr("data-modaal-custom-class")&&(e=!0,o.custom_class=t.attr("data-modaal-custom-class")),t.attr("data-modaal-close-text")&&(e=!0,o.close_text=t.attr("data-modaal-close-text")),t.attr("data-modaal-close-aria-label")&&(e=!0,o.close_aria_label=t.attr("data-modaal-close-aria-label")),t.attr("data-modaal-background-scroll")&&(e=!0,o.background_scroll="true"===t.attr("data-modaal-background-scroll")),t.attr("data-modaal-width")&&(e=!0,o.width=parseInt(t.attr("data-modaal-width"))),t.attr("data-modaal-height")&&(e=!0,o.height=parseInt(t.attr("data-modaal-height"))),t.attr("data-modaal-confirm-button-text")&&(e=!0,o.confirm_button_text=t.attr("data-modaal-confirm-button-text")),t.attr("data-modaal-confirm-cancel-button-text")&&(e=!0,o.confirm_cancel_button_text=t.attr("data-modaal-confirm-cancel-button-text")),t.attr("data-modaal-confirm-title")&&(e=!0,o.confirm_title=t.attr("data-modaal-confirm-title")),t.attr("data-modaal-confirm-content")&&(e=!0,o.confirm_content=t.attr("data-modaal-confirm-content")),t.attr("data-modaal-gallery-active-class")&&(e=!0,o.gallery_active_class=t.attr("data-modaal-gallery-active-class")),t.attr("data-modaal-loading-content")&&(e=!0,o.loading_content=t.attr("data-modaal-loading-content")),t.attr("data-modaal-loading-class")&&(e=!0,o.loading_class=t.attr("data-modaal-loading-class")),t.attr("data-modaal-ajax-error-class")&&(e=!0,o.ajax_error_class=t.attr("data-modaal-ajax-error-class")),t.attr("data-modaal-instagram-id")&&(e=!0,o.instagram_id=t.attr("data-modaal-instagram-id")),e&&t.modaal(o)})})}(jQuery,window,document);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * jquery.mask.js
	 * @version: v1.14.16
	 * @author: Igor Escobar
	 *
	 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
	 *
	 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
	 *
	 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/* jshint laxbreak: true */
	/* jshint maxcomplexity:17 */
	/* global define */
	
	// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
	// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
	(function (factory, jQuery, Zepto) {
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery || Zepto);
	    }
	
	}(function ($) {
	    'use strict';
	
	    var Mask = function (el, mask, options) {
	
	        var p = {
	            invalid: [],
	            getCaret: function () {
	                try {
	                    var sel,
	                        pos = 0,
	                        ctrl = el.get(0),
	                        dSel = document.selection,
	                        cSelStart = ctrl.selectionStart;
	
	                    // IE Support
	                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
	                        sel = dSel.createRange();
	                        sel.moveStart('character', -p.val().length);
	                        pos = sel.text.length;
	                    }
	                    // Firefox support
	                    else if (cSelStart || cSelStart === '0') {
	                        pos = cSelStart;
	                    }
	
	                    return pos;
	                } catch (e) {}
	            },
	            setCaret: function(pos) {
	                try {
	                    if (el.is(':focus')) {
	                        var range, ctrl = el.get(0);
	
	                        // Firefox, WebKit, etc..
	                        if (ctrl.setSelectionRange) {
	                            ctrl.setSelectionRange(pos, pos);
	                        } else { // IE
	                            range = ctrl.createTextRange();
	                            range.collapse(true);
	                            range.moveEnd('character', pos);
	                            range.moveStart('character', pos);
	                            range.select();
	                        }
	                    }
	                } catch (e) {}
	            },
	            events: function() {
	                el
	                .on('keydown.mask', function(e) {
	                    el.data('mask-keycode', e.keyCode || e.which);
	                    el.data('mask-previus-value', el.val());
	                    el.data('mask-previus-caret-pos', p.getCaret());
	                    p.maskDigitPosMapOld = p.maskDigitPosMap;
	                })
	                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
	                .on('paste.mask drop.mask', function() {
	                    setTimeout(function() {
	                        el.keydown().keyup();
	                    }, 100);
	                })
	                .on('change.mask', function(){
	                    el.data('changed', true);
	                })
	                .on('blur.mask', function(){
	                    if (oldValue !== p.val() && !el.data('changed')) {
	                        el.trigger('change');
	                    }
	                    el.data('changed', false);
	                })
	                // it's very important that this callback remains in this position
	                // otherwhise oldValue it's going to work buggy
	                .on('blur.mask', function() {
	                    oldValue = p.val();
	                })
	                // select all text on focus
	                .on('focus.mask', function (e) {
	                    if (options.selectOnFocus === true) {
	                        $(e.target).select();
	                    }
	                })
	                // clear the value if it not complete the mask
	                .on('focusout.mask', function() {
	                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
	                       p.val('');
	                   }
	                });
	            },
	            getRegexMask: function() {
	                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;
	
	                for (var i = 0; i < mask.length; i++) {
	                    translation = jMask.translation[mask.charAt(i)];
	
	                    if (translation) {
	
	                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
	                        optional = translation.optional;
	                        recursive = translation.recursive;
	
	                        if (recursive) {
	                            maskChunks.push(mask.charAt(i));
	                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
	                        } else {
	                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
	                        }
	
	                    } else {
	                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	                    }
	                }
	
	                r = maskChunks.join('');
	
	                if (oRecursive) {
	                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
	                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
	                }
	
	                return new RegExp(r);
	            },
	            destroyEvents: function() {
	                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
	            },
	            val: function(v) {
	                var isInput = el.is('input'),
	                    method = isInput ? 'val' : 'text',
	                    r;
	
	                if (arguments.length > 0) {
	                    if (el[method]() !== v) {
	                        el[method](v);
	                    }
	                    r = el;
	                } else {
	                    r = el[method]();
	                }
	
	                return r;
	            },
	            calculateCaretPosition: function(oldVal) {
	                var newVal = p.getMasked(),
	                    caretPosNew = p.getCaret();
	                if (oldVal !== newVal) {
	                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
	                        newValL = newVal.length,
	                        oldValL = oldVal.length,
	                        maskDigitsBeforeCaret = 0,
	                        maskDigitsAfterCaret = 0,
	                        maskDigitsBeforeCaretAll = 0,
	                        maskDigitsBeforeCaretAllOld = 0,
	                        i = 0;
	
	                    for (i = caretPosNew; i < newValL; i++) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsAfterCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsBeforeCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMap[i]) {
	                            maskDigitsBeforeCaretAll++;
	                        }
	                    }
	
	                    for (i = caretPosOld - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMapOld[i]) {
	                            maskDigitsBeforeCaretAllOld++;
	                        }
	                    }
	
	                    // if the cursor is at the end keep it there
	                    if (caretPosNew > oldValL) {
	                      caretPosNew = newValL * 10;
	                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
	                        if (!p.maskDigitPosMapOld[caretPosNew])  {
	                          var caretPos = caretPosNew;
	                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
	                          caretPosNew -= maskDigitsBeforeCaret;
	                          if (p.maskDigitPosMap[caretPosNew])  {
	                            caretPosNew = caretPos;
	                          }
	                        }
	                    }
	                    else if (caretPosNew > caretPosOld) {
	                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
	                        caretPosNew += maskDigitsAfterCaret;
	                    }
	                }
	                return caretPosNew;
	            },
	            behaviour: function(e) {
	                e = e || window.event;
	                p.invalid = [];
	
	                var keyCode = el.data('mask-keycode');
	
	                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
	                    var newVal = p.getMasked(),
	                        caretPos = p.getCaret(),
	                        oldVal = el.data('mask-previus-value') || '';
	
	                    // this is a compensation to devices/browsers that don't compensate
	                    // caret positioning the right way
	                    setTimeout(function() {
	                      p.setCaret(p.calculateCaretPosition(oldVal));
	                    }, $.jMaskGlobals.keyStrokeCompensation);
	
	                    p.val(newVal);
	                    p.setCaret(caretPos);
	                    return p.callbacks(e);
	                }
	            },
	            getMasked: function(skipMaskChars, val) {
	                var buf = [],
	                    value = val === undefined ? p.val() : val + '',
	                    m = 0, maskLen = mask.length,
	                    v = 0, valLen = value.length,
	                    offset = 1, addMethod = 'push',
	                    resetPos = -1,
	                    maskDigitCount = 0,
	                    maskDigitPosArr = [],
	                    lastMaskChar,
	                    check;
	
	                if (options.reverse) {
	                    addMethod = 'unshift';
	                    offset = -1;
	                    lastMaskChar = 0;
	                    m = maskLen - 1;
	                    v = valLen - 1;
	                    check = function () {
	                        return m > -1 && v > -1;
	                    };
	                } else {
	                    lastMaskChar = maskLen - 1;
	                    check = function () {
	                        return m < maskLen && v < valLen;
	                    };
	                }
	
	                var lastUntranslatedMaskChar;
	                while (check()) {
	                    var maskDigit = mask.charAt(m),
	                        valDigit = value.charAt(v),
	                        translation = jMask.translation[maskDigit];
	
	                    if (translation) {
	                        if (valDigit.match(translation.pattern)) {
	                            buf[addMethod](valDigit);
	                             if (translation.recursive) {
	                                if (resetPos === -1) {
	                                    resetPos = m;
	                                } else if (m === lastMaskChar && m !== resetPos) {
	                                    m = resetPos - offset;
	                                }
	
	                                if (lastMaskChar === resetPos) {
	                                    m -= offset;
	                                }
	                            }
	                            m += offset;
	                        } else if (valDigit === lastUntranslatedMaskChar) {
	                            // matched the last untranslated (raw) mask character that we encountered
	                            // likely an insert offset the mask character from the last entry; fall
	                            // through and only increment v
	                            maskDigitCount--;
	                            lastUntranslatedMaskChar = undefined;
	                        } else if (translation.optional) {
	                            m += offset;
	                            v -= offset;
	                        } else if (translation.fallback) {
	                            buf[addMethod](translation.fallback);
	                            m += offset;
	                            v -= offset;
	                        } else {
	                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
	                        }
	                        v += offset;
	                    } else {
	                        if (!skipMaskChars) {
	                            buf[addMethod](maskDigit);
	                        }
	
	                        if (valDigit === maskDigit) {
	                            maskDigitPosArr.push(v);
	                            v += offset;
	                        } else {
	                            lastUntranslatedMaskChar = maskDigit;
	                            maskDigitPosArr.push(v + maskDigitCount);
	                            maskDigitCount++;
	                        }
	
	                        m += offset;
	                    }
	                }
	
	                var lastMaskCharDigit = mask.charAt(lastMaskChar);
	                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
	                    buf.push(lastMaskCharDigit);
	                }
	
	                var newVal = buf.join('');
	                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
	                return newVal;
	            },
	            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
	              var maskDiff = options.reverse ? newVal.length - valLen : 0;
	              p.maskDigitPosMap = {};
	              for (var i = 0; i < maskDigitPosArr.length; i++) {
	                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
	              }
	            },
	            callbacks: function (e) {
	                var val = p.val(),
	                    changed = val !== oldValue,
	                    defaultArgs = [val, e, el, options],
	                    callback = function(name, criteria, args) {
	                        if (typeof options[name] === 'function' && criteria) {
	                            options[name].apply(this, args);
	                        }
	                    };
	
	                callback('onChange', changed === true, defaultArgs);
	                callback('onKeyPress', changed === true, defaultArgs);
	                callback('onComplete', val.length === mask.length, defaultArgs);
	                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
	            }
	        };
	
	        el = $(el);
	        var jMask = this, oldValue = p.val(), regexMask;
	
	        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;
	
	        // public methods
	        jMask.mask = mask;
	        jMask.options = options;
	        jMask.remove = function() {
	            var caret = p.getCaret();
	            if (jMask.options.placeholder) {
	                el.removeAttr('placeholder');
	            }
	            if (el.data('mask-maxlength')) {
	                el.removeAttr('maxlength');
	            }
	            p.destroyEvents();
	            p.val(jMask.getCleanVal());
	            p.setCaret(caret);
	            return el;
	        };
	
	        // get value without mask
	        jMask.getCleanVal = function() {
	           return p.getMasked(true);
	        };
	
	        // get masked value without the value being in the input or element
	        jMask.getMaskedVal = function(val) {
	           return p.getMasked(false, val);
	        };
	
	       jMask.init = function(onlyMask) {
	            onlyMask = onlyMask || false;
	            options = options || {};
	
	            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
	            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
	            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);
	
	            jMask = $.extend(true, {}, jMask, options);
	
	            regexMask = p.getRegexMask();
	
	            if (onlyMask) {
	                p.events();
	                p.val(p.getMasked());
	            } else {
	                if (options.placeholder) {
	                    el.attr('placeholder' , options.placeholder);
	                }
	
	                // this is necessary, otherwise if the user submit the form
	                // and then press the "back" button, the autocomplete will erase
	                // the data. Works fine on IE9+, FF, Opera, Safari.
	                if (el.data('mask')) {
	                  el.attr('autocomplete', 'off');
	                }
	
	                // detect if is necessary let the user type freely.
	                // for is a lot faster than forEach.
	                for (var i = 0, maxlength = true; i < mask.length; i++) {
	                    var translation = jMask.translation[mask.charAt(i)];
	                    if (translation && translation.recursive) {
	                        maxlength = false;
	                        break;
	                    }
	                }
	
	                if (maxlength) {
	                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
	                }
	
	                p.destroyEvents();
	                p.events();
	
	                var caret = p.getCaret();
	                p.val(p.getMasked());
	                p.setCaret(caret);
	            }
	        };
	
	        jMask.init(!el.is('input'));
	    };
	
	    $.maskWatchers = {};
	    var HTMLAttributes = function () {
	        var input = $(this),
	            options = {},
	            prefix = 'data-mask-',
	            mask = input.attr('data-mask');
	
	        if (input.attr(prefix + 'reverse')) {
	            options.reverse = true;
	        }
	
	        if (input.attr(prefix + 'clearifnotmatch')) {
	            options.clearIfNotMatch = true;
	        }
	
	        if (input.attr(prefix + 'selectonfocus') === 'true') {
	           options.selectOnFocus = true;
	        }
	
	        if (notSameMaskObject(input, mask, options)) {
	            return input.data('mask', new Mask(this, mask, options));
	        }
	    },
	    notSameMaskObject = function(field, mask, options) {
	        options = options || {};
	        var maskObject = $(field).data('mask'),
	            stringify = JSON.stringify,
	            value = $(field).val() || $(field).text();
	        try {
	            if (typeof mask === 'function') {
	                mask = mask(value);
	            }
	            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
	        } catch (e) {}
	    },
	    eventSupported = function(eventName) {
	        var el = document.createElement('div'), isSupported;
	
	        eventName = 'on' + eventName;
	        isSupported = (eventName in el);
	
	        if ( !isSupported ) {
	            el.setAttribute(eventName, 'return;');
	            isSupported = typeof el[eventName] === 'function';
	        }
	        el = null;
	
	        return isSupported;
	    };
	
	    $.fn.mask = function(mask, options) {
	        options = options || {};
	        var selector = this.selector,
	            globals = $.jMaskGlobals,
	            interval = globals.watchInterval,
	            watchInputs = options.watchInputs || globals.watchInputs,
	            maskFunction = function() {
	                if (notSameMaskObject(this, mask, options)) {
	                    return $(this).data('mask', new Mask(this, mask, options));
	                }
	            };
	
	        $(this).each(maskFunction);
	
	        if (selector && selector !== '' && watchInputs) {
	            clearInterval($.maskWatchers[selector]);
	            $.maskWatchers[selector] = setInterval(function(){
	                $(document).find(selector).each(maskFunction);
	            }, interval);
	        }
	        return this;
	    };
	
	    $.fn.masked = function(val) {
	        return this.data('mask').getMaskedVal(val);
	    };
	
	    $.fn.unmask = function() {
	        clearInterval($.maskWatchers[this.selector]);
	        delete $.maskWatchers[this.selector];
	        return this.each(function() {
	            var dataMask = $(this).data('mask');
	            if (dataMask) {
	                dataMask.remove().removeData('mask');
	            }
	        });
	    };
	
	    $.fn.cleanVal = function() {
	        return this.data('mask').getCleanVal();
	    };
	
	    $.applyDataMask = function(selector) {
	        selector = selector || $.jMaskGlobals.maskElements;
	        var $selector = (selector instanceof $) ? selector : $(selector);
	        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
	    };
	
	    var globals = {
	        maskElements: 'input,td,span,div',
	        dataMaskAttr: '*[data-mask]',
	        dataMask: true,
	        watchInterval: 300,
	        watchInputs: true,
	        keyStrokeCompensation: 10,
	        // old versions of chrome dont work great with input event
	        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
	        watchDataMask: false,
	        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
	        translation: {
	            '0': {pattern: /\d/},
	            '9': {pattern: /\d/, optional: true},
	            '#': {pattern: /\d/, recursive: true},
	            'A': {pattern: /[a-zA-Z0-9]/},
	            'S': {pattern: /[a-zA-Z]/}
	        }
	    };
	
	    $.jMaskGlobals = $.jMaskGlobals || {};
	    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);
	
	    // looking for inputs with data-mask attribute
	    if (globals.dataMask) {
	        $.applyDataMask();
	    }
	
	    setInterval(function() {
	        if ($.jMaskGlobals.watchDataMask) {
	            $.applyDataMask();
	        }
	    }, globals.watchInterval);
	}, __webpack_provided_window_dot_jQuery, window.Zepto));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })
]);


// WEBPACK FOOTER //
// contact-modal.min.js